import { Editor } from "@tiptap/react";

export const countRowsInActiveTable = (editor: Editor) => {
  const { state } = editor;
  const { $from } = state.selection;
  let tableNode = null;
  for (let depth = $from.depth; depth > 0; depth--) {
    const node = $from.node(depth);
    if (node.type.name === "table") {
      tableNode = node;
      break;
    }
  }
  if (tableNode) {
    let rowCount = 0;
    tableNode.forEach((node) => {
      if (node.type.name === "tableRow") rowCount++;
    });
    return rowCount;
  }
  return 0;
};

export const countColumnsInActiveTable = (editor: Editor) => {
  const { state } = editor;
  const { $from } = state.selection;
  let tableNode = null;
  for (let depth = $from.depth; depth > 0; depth--) {
    const node = $from.node(depth);
    if (node.type.name === "table") {
      tableNode = node;
      break;
    }
  }
  if (tableNode) {
    let colCount = 0;
    tableNode.forEach((rowNode) => {
      if (rowNode.type.name === "tableRow" && colCount === 0) {
        rowNode.forEach(() => colCount++);
      }
    });
    return colCount;
  }
  return 0;
};
